/* istanbul ignore file */
import React, { ReactElement } from "react";
import { Debug } from "../formik/Debug";

export const DevDebug = /*#__PURE__*/ (): ReactElement | null => {
  return process.env.NODE_ENV === "development" ? <Debug /> : null;
};
